    import React from 'react';
    import { Outlet } from 'react-router-dom';
    import SubNavigator from '../../components/SubNavigator';
    import { PageContainer, SideNavigation, SectionContainer, SectionHeading, MainContent } from '../../components/SubNavigator';

    const sections = [
    
      {
        heading: '나의 정보관리',
        links: [
          { path: '/Settings/MyPage', label: '회원정보관리' },
          { path: '/Settings/UserCorptax', label: '계산서관리' }
        ],
      },
      {
        heading: '파이/결제 관리',
        links: [
          { path: '/Settings/Withdraw', label: '파이 충전' },
          { path: '/Settings/PointDeposit', label: '파이 출금' },
          { path: '/Settings/PointUsageHistory', label: '파이 상세내역' },
        ],
      },
      // {
      //   heading: '이벤트현황',
      //   links: [
      //     { path: '/Settings/PaymentRecords', label: '보너스적립현황' }
      //   ],
      // },

    ];


    export default function Settings() {
      return (
        <PageContainer>
          <SideNavigation> {/* 네비게이션을 좌측으로 배치 */}
            {sections.map((section, index) => (
              <SectionContainer key={index}>
                <SectionHeading>{section.heading}</SectionHeading>
                <SubNavigator links={section.links} />
              </SectionContainer>
            ))}
          </SideNavigation>
          <MainContent> {/* 메인 컨텐츠는 나머지 공간을 차지 */}
            <Outlet />
          </MainContent>
        </PageContainer>
      );
    }